import { createRef, Component } from "react";
import ReactDOMServer from "react-dom/server";

import classNames from "classnames";

import { ErrorView } from "common/components/error";
import { CheckBox } from "common/components/checkbox";
import { OptionsButton } from "common/components/buttons/optionsButton";

import { Webix } from "common/components/webix/react/webix";

class ExportDialog extends Component {
    constructor(props) {
        super(props);
        this.list_ref = createRef();
        this.state = {
            config: { data: [] },
            fileName: this.props.exportOptions.suggested_name,
            fileFormat: "csv",
            automaticDownload: false,
            sortOrder: "config",
            hasError: false,
            exportAll: false
        };
        this.ui = {
            view: "list",
            minHeight: 300,
            minWidth: 500,
            autowidth: true,
            select: false,
            scrollY: false,
            template: (obj) => ReactDOMServer.renderToStaticMarkup(
                <CheckBox className="export-list-checkbox" label={obj.header} value={obj.will_export} onChange={() => {}} name={toString(obj.id)} />
            ),
            adjust: true,
            on: {
                onItemClick: this.toggleVisibility
            }
        };
    }

    componentDidMount() {
        const { data } = this.props.config;
        this.setState({
            config: {
                ...this.props.config,
                data: data?.map((item, index) => ({ weight: index, ...item, will_export: item.collapsed_visible }))
            }
        });
    }

    getSnapshotBeforeUpdate() {
        const node = this.list_ref.current.getWebixElement().getNode();
        return {
            listScrollTop: node.scrollTop
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!this.state.hasError) {
            const list = this.list_ref.current.getWebixElement();
            list.refresh();
            if (snapshot !== null) {
                list.getNode().scrollTop = snapshot.listScrollTop;
            }
        }
    }

    componentWillUnmount() {
        this.list_ref = null;
    }

    toggleVisibility = (id, e, node) => {
        const getter = this.list_ref.current.ui.getItem(id);
        this.setState(
            (prevState) => {
                const data = prevState.config.data
                    .map((item) => (item._id === getter._id ? { ...item, will_export: !item.will_export } : { ...item }));
                return { config: { ...prevState.config, data } };
            }
        );
    };

    handleExportAll = (e) => {
        this.handleChange(e);
        this.setState(
            (prevState) => ({
                config: {
                    ...prevState.config,
                    data: prevState.config.data.map((item) => ({ ...item, will_export: e.target.value }))
                }
            })
        );
    };

    setSortOrder = (sortOrder) => () => this.setState({ sortOrder });

    onExportClicked = () => {
        try {
            const exportValues = this.prepareExport();
            this.props.onExportClicked(exportValues);
            this.props.close();
        } catch (error) {
            this.setState({ hasError: true, error });
        }
    };
    
    prepareExport = () => ({
        filename: this.state.fileName,
        shouldStartDownloadAutomatically: this.state.automaticDownload,
        headers: this.state.config.data.reduce((memo, { _id, will_export }) => (will_export ? [...memo, _id] : memo), [])
        // content_type: this.state.fileFormat,
    });

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    };

    handleFormatChange = (fileFormat) => this.setState({ fileFormat });

    renderActions = () => (
        <div className="actions">
            <div className="group" />
            <div className="group">
                <button type="button" className="btn btn-muted" onClick={this.props.close}>Close</button>
                <button type="button" className="btn btn-secondary bright" onClick={this.onExportClicked}>Export</button>
            </div>
        </div>
    );

    render() {
        if (this.state.hasError) {
            return (
                <div className="configurable-table-export table-export">
                    <ErrorView
                        error={this.state.error}
                        header="Export failed"
                        message="Something went wrong during the export. Try to refresh page."
                        hideDetails
                        captureInSentry
                        custom
                    />
                </div>
            );
        }
        const columns_list = this.state.config.data
            .map((item) => ({ ...item, header: item.name }))
            .sort((a, b) => {
                if (this.state.sortOrder === "config") {
                    return a.weight > b.weight ? 1 : -1;
                }
                return a.header > b.header ? 1 : -1;
            });
        const formats = this.props.exportOptions.formats?.map((format) => ({ ...format, onClick: this.handleFormatChange })) || [];

        return (
            <div className="configurable-table-export table-export">
                <div className="file-name">
                    <div className="field-name">File name</div>
                    <input type="text" className="form-control fileName" name="fileName" value={this.state.fileName} onChange={this.handleChange} />
                </div>
                {formats.length !== 0 && (
                <div className="format-options">
                    <div className="field-name">File format</div>
                    <OptionsButton structure={formats} activeValue={this.state.fileFormat} />
                </div>
                )}
                <div className="list-header">
                    <CheckBox label="Select all fields" onChange={this.handleExportAll} name="exportAll" value={this.state.exportAll} />
                    <div className="sort_order">
                        Sort by:
                        <span className={classNames(["sort-button", { active: this.state.sortOrder === "config" }])} onClick={this.setSortOrder("config")}>Export order</span>|
                        <span className={classNames(["sort-button", { active: this.state.sortOrder === "az" }])} onClick={this.setSortOrder("az")}>A-Z</span>
                    </div>
                </div>
                <Webix className="config-columns" ui={this.ui} data={columns_list} ref={this.list_ref} />
                {this.props.enableAutomaticDownload && <CheckBox label="Automatically download when ready" name="automaticDownload" onChange={this.handleChange} value={this.state.automaticDownload} />}
                {this.renderActions()}
            </div>
        );
    }
}

export { ExportDialog };
